import React from 'react';
import './SpacedParagraph.css';

const SpacedParagraph = ({ text }) => {
  return (
    <p className="Paragraph">
      {text}
    </p>
  );
};

export default SpacedParagraph;



// WEBPACK FOOTER //
// ./src/components/UtilityComponents/SpacedParagraph/index.js